import Customers from './Customers';
import './Customers.scss';

export default Customers;
